var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dam-layout',[_c('base-heading',[_vm._v("DAM: Portal page to be built")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }